import { AxiosError } from 'axios';
import { FilterModel } from '../model/ui/filter.model';
import { FilterType } from '../model/ui/filter.type';

export const isValidUrl = (url?: string) => {
  try {
    new URL(url ?? '');
  } catch (e) {
    return false;
  }
  return true;
};

export const formatPrice = (cents: number): string => {
  return (cents / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const hasAppliedListFilters = (filters: FilterModel[]): boolean => {
  return filters?.some((filter) => {
    if (filter.type === FilterType.slider) {
      const value = filter.value as [number, number] | undefined;
      if (!Array.isArray(value) || value.length !== 2) {
        return false;
      }
      const [selectedMin, selectedMax] = value;
      return selectedMin !== filter.min || selectedMax !== filter.max;
    }

    return filter.value !== '';
  });
};

export function getAxiosErrorMessage(error: unknown): string {
  const axiosError = error as AxiosError<any> | undefined;
  const data = axiosError?.response?.data as any;

  if (data?.error && data?.message) {
    const msg = Array.isArray(data.message)
      ? data.message.join(', ')
      : String(data.message);
    return `${data.error}: ${msg}`;
  }

  return axiosError?.message ?? (error as Error)?.message ?? 'Unknown error';
}
